import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookie from 'vue-cookie'

import en from '@/plugins/i18n/en'
import da from '@/plugins/i18n/da'

Vue.use(VueI18n)

let userLanguage = Cookie.get('USER_LANGUAGE')
if (!userLanguage) {
  userLanguage = navigator.language || navigator.userLanguage
  if (userLanguage && userLanguage.length > 2) {
    userLanguage = userLanguage.substring(0, 2)
  }
}
if (!userLanguage) {
  userLanguage = 'en'
}

const messages = {
  en,
  da
}

export default new VueI18n({
  locale: userLanguage,
  fallbackLocale: 'en',
  messages
})



// WEBPACK FOOTER //
// ./src/plugins/i18n.js